// extracted by mini-css-extract-plugin
export default {"noData":"DisplayValue_noData__yznlF"};